import PropTypes from 'prop-types';

const LeaveIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.439 33c5.666 0 7.78-2.365 7.6-5.387 0 0-.045-.794-.09-1.542-.05-.806.641-1.543 1.704-1.834A29.304 29.304 0 0 1 24 23.243c2.48.019 4.949.353 7.347.994 1.063.291 1.754 1.028 1.704 1.834-.045.748-.09 1.542-.09 1.542-.18 3.022 1.934 5.387 7.6 5.387 8.748 0 8.28-4.187 6.1-7.557a19.864 19.864 0 0 0-5.886-5.736C36.058 16.617 30.038 15.046 24 15c-6.038.046-12.058 1.617-16.775 4.707a19.863 19.863 0 0 0-5.886 5.736C-.84 28.813-1.309 33 7.44 33z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

LeaveIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

LeaveIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default LeaveIcon;
